<script lang="ts">
  import { fade } from 'svelte/transition';
  import { Container } from '../../services/container';
  import { AppState } from '../../etc/stores';
  import { Auth } from '../../services/auth';
  import { useInternalModal } from '../../etc/hooks/useModalInternal';

  const { close } = useInternalModal();
  const auth = Container.get(Auth);

  $: component = $AppState.website.internalModal.component;
  $: isVisible = $AppState.website.internalModal.isVisible;
  $: options = $AppState.website.internalModal.options || {};

  AppState.subscribe(({ website }) => {
    if (!website.popoverOpen && website.internalModal.isVisible) {
      AppState.update(state => ({
        ...state,
        website: {
          ...state.website,
          internalModal: {
            ...state.website.internalModal,
            isVisible: false
          }
        }
      }));
    }
  });
</script>

{#if isVisible && !!component}
  <div
    class="twism-internalmodal-wrapper {auth.provider}"
    in:fade={{ delay: 500, duration: 300 }}
  >
    <div
      class="twism-internalmodal-background {options.fullHeight
        ? 'full-height'
        : ''}"
      on:click={() => !options.disabledClose && close()}
      out:fade={{ duration: 100 }}
    />
    <div class="twism-internalmodal-container">
      <svelte:component this={component} />
    </div>
  </div>
{/if}

<style lang="scss">
  .twism-internalmodal {
    &-wrapper {
      display: flex;
      position: absolute;
      top: 62px;
      right: 0;
      left: 0;
      bottom: 0;
      width: 100%;
      height: calc(100% - 62px);
      align-items: center;
      justify-content: center;

      &.wix {
        z-index: calc(var(--above-all-z-index) - 5);
      }

      &.woocommerce,
      &.shopify,
      &.bigcommerce {
        z-index: 10;
      }
    }

    &-background {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.6);
      z-index: -1;

      &.full-height {
        top: 0;
        height: 100%;
      }
    }

    &-container {
      display: flex !important;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      border-radius: 16px;
    }
  }
</style>
